import i18n from "i18next";

import {
    MalePrimaryGoalAnswersReorderReactionExp,
    MalePrimaryGoalAnswersUpgraded,
    PrimaryGoalAnswersGLP1Exp,
} from "@/types/answers";

export enum FitnessGoals {
    GainMuscle = "gainMuscle",
    GetInShape = "getInShape",
    LoseWeight = "loseWeight",
    BeHealthy = "beHealthy",
    GetActive = "getActive",
}

export const goalTextById: { [key in FitnessGoals]?: string } = {
    [FitnessGoals.GainMuscle]: i18n.t("muscle_gain"),
    [FitnessGoals.LoseWeight]: i18n.t("weight_loss"),
    [FitnessGoals.GetActive]: i18n.t("fitness"),
    [FitnessGoals.BeHealthy]: i18n.t("stay_active"),
    [FitnessGoals.GetInShape]: i18n.t("get_in_shape"),
};

export const goalTextByIdChartImage: { [key in FitnessGoals]?: string } = {
    [FitnessGoals.GainMuscle]: i18n.t("gain_muscle"),
    [FitnessGoals.GetInShape]: i18n.t("get_in_shape"),
    [FitnessGoals.LoseWeight]: i18n.t("lose_weight"),
    [FitnessGoals.GetActive]: i18n.t("stay_fit"),
    [FitnessGoals.BeHealthy]: i18n.t("stay_active"),
};

export const primaryGoalTextById: { [key in PrimaryGoalAnswersGLP1Exp]: string } = {
    [PrimaryGoalAnswersGLP1Exp.MuscleSafeWeightLoss]: i18n.t("muscle_safe_weight_loss"),
    [PrimaryGoalAnswersGLP1Exp.MaintainMyResultsAfterGlp1]: i18n.t(
        "maintain_my_results_after_glp_1"
    ),
    [PrimaryGoalAnswersGLP1Exp.FirmUpAndRegainTone]: i18n.t("firm_up_and_regain_tone"),
    [PrimaryGoalAnswersGLP1Exp.GetStronger]: i18n.t("get_stronger"),
};

export const maleReorderReactionScreenGoalTextById: {
    [key in MalePrimaryGoalAnswersReorderReactionExp | PrimaryGoalAnswersGLP1Exp]?: string;
} = {
    [MalePrimaryGoalAnswersReorderReactionExp.FirmerDefinedBody]: i18n.t("firmer_defined_body"),
    [MalePrimaryGoalAnswersReorderReactionExp.MoreMuscleStrength]: i18n.t("more_muscle_strength"),
    [MalePrimaryGoalAnswersReorderReactionExp.EffectiveWeightLoss]: i18n.t("effective_weight_loss"),
    [MalePrimaryGoalAnswersReorderReactionExp.MentalBalanceStressRelief]: i18n.t(
        "mental_balance_stress_relief"
    ),
    [PrimaryGoalAnswersGLP1Exp.MuscleSafeWeightLoss]: i18n.t("muscle_safe_weight_loss"),
    [PrimaryGoalAnswersGLP1Exp.MaintainMyResultsAfterGlp1]: i18n.t(
        "maintain_my_results_after_glp_1"
    ),
    [PrimaryGoalAnswersGLP1Exp.FirmUpAndRegainTone]: i18n.t("firm_up_and_regain_tone"),
    [PrimaryGoalAnswersGLP1Exp.GetStronger]: i18n.t("get_stronger"),
};

export const calisthenicsActionPlanTextByGoal: { [key in FitnessGoals]?: string } = {
    [FitnessGoals.GainMuscle]: i18n.t("gain_muscle"),
    [FitnessGoals.LoseWeight]: i18n.t("lose_weight"),
    [FitnessGoals.GetActive]: "reach your peak form",
    [FitnessGoals.BeHealthy]: "reach your peak form",
    [FitnessGoals.GetInShape]: i18n.t("get_in_shape"),
};

export const calisthenicsEventTextByGoal: { [key in FitnessGoals]?: string } = {
    [FitnessGoals.GainMuscle]: i18n.t("gain_muscle"),
    [FitnessGoals.LoseWeight]: i18n.t("lose_weight"),
    [FitnessGoals.GetActive]: "be at your peak form",
    [FitnessGoals.BeHealthy]: "be at your peak form",
    [FitnessGoals.GetInShape]: i18n.t("get_in_shape"),
};

export const goalIngTextById: Record<FitnessGoals, string> = {
    [FitnessGoals.GainMuscle]: i18n.t("gaining_muscle"),
    [FitnessGoals.LoseWeight]: i18n.t("losing_weight"),
    [FitnessGoals.GetInShape]: i18n.t("getting_in_shape"),
    [FitnessGoals.BeHealthy]: i18n.t("being_healthy"),
    [FitnessGoals.GetActive]: i18n.t("getting_active"),
};

// Seniors funnel

export const seniorsGoalTextById: Record<FitnessGoals, string> = {
    [FitnessGoals.GainMuscle]: "",
    [FitnessGoals.LoseWeight]: "Lose Weight",
    [FitnessGoals.GetInShape]: "",
    [FitnessGoals.BeHealthy]: "",
    [FitnessGoals.GetActive]: "Maintain weight and get fit",
};

export const seniorsGoalIngTextById: Record<FitnessGoals, string> = {
    [FitnessGoals.GainMuscle]: "",
    [FitnessGoals.LoseWeight]: i18n.t("losing_weight"),
    [FitnessGoals.GetInShape]: "",
    [FitnessGoals.BeHealthy]: "",
    [FitnessGoals.GetActive]: "Maintain weight and get fit",
};

//mapping for experiment reorder reaction screen
export const malePrimaryGoalToFitnessGoalMap: Record<
    MalePrimaryGoalAnswersReorderReactionExp | PrimaryGoalAnswersGLP1Exp,
    FitnessGoals
> = {
    [MalePrimaryGoalAnswersReorderReactionExp.MoreMuscleStrength]: FitnessGoals.GainMuscle,
    [MalePrimaryGoalAnswersReorderReactionExp.FirmerDefinedBody]: FitnessGoals.GetInShape,
    [MalePrimaryGoalAnswersReorderReactionExp.EffectiveWeightLoss]: FitnessGoals.LoseWeight,
    [MalePrimaryGoalAnswersReorderReactionExp.MentalBalanceStressRelief]: FitnessGoals.GetInShape,
    [PrimaryGoalAnswersGLP1Exp.MuscleSafeWeightLoss]: FitnessGoals.LoseWeight,
    [PrimaryGoalAnswersGLP1Exp.MaintainMyResultsAfterGlp1]: FitnessGoals.GetInShape,
    [PrimaryGoalAnswersGLP1Exp.FirmUpAndRegainTone]: FitnessGoals.GetInShape,
    [PrimaryGoalAnswersGLP1Exp.GetStronger]: FitnessGoals.GainMuscle,
};

export const malePrimaryGoalToFitnessGoalUpgradedMap: Record<
    MalePrimaryGoalAnswersUpgraded,
    FitnessGoals
> = {
    [MalePrimaryGoalAnswersUpgraded.MoreMuscle]: FitnessGoals.GainMuscle,
    [MalePrimaryGoalAnswersUpgraded.FirmerBody]: FitnessGoals.GetInShape,
    [MalePrimaryGoalAnswersUpgraded.WeightLoss]: FitnessGoals.LoseWeight,
    [MalePrimaryGoalAnswersUpgraded.ReduceStress]: FitnessGoals.GetInShape,
};
